import moment from 'moment'

export const dateFilter = (value, format = 'DD-MM-YYYY HH:mm:ss') => {
  if (!value) return null
  return moment(value).format(format)
}
